import { getDspEnvConfig } from './config/dspEnv';

const dspConfig = getDspEnvConfig();

// Configure local-development globals. The DSP base URL is NOT set here: DSP
// requests always resolve from the env var via getDspBaseUrl(), never from
// window.API_BASE_URL (the platform's same-origin /api proxy).
if (process.env.NODE_ENV === 'development') {
  window.COMPANY_ID = process.env.COMPANY_ID || '6419d68d33c59c85e30cdc62';
  console.log('🔧 Development mode: COMPANY_ID set to:', window.COMPANY_ID);
  window.CONTENT_BASE_URL = process.env.CONTENT_BASE_URL || process.env.REACT_APP_CDN_URL || '';
  console.log('🔧 Development mode: CONTENT_BASE_URL set to:', window.CONTENT_BASE_URL);
  // Image base overrides only; REACT_APP_CDN_URL is the *video* content CDN and
  // must never be used as an image base (the API supplies that via /init/config).
  window.IMAGES_BASE_URL = process.env.IMAGES_BASE_URL || '';
  console.log('🔧 Development mode: IMAGES_BASE_URL set to:', window.IMAGES_BASE_URL);
  window.EMBEDDED_JWT = process.env.REACT_APP_SPOTLIGHT_API_TOKEN || dspConfig.apiKey;
  console.log(
    '🔧 Development mode: EMBEDDED_JWT set to:',
    window.EMBEDDED_JWT ? '[REDACTED]' : 'undefined',
  );
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { tokenService } from './services/auth/TokenService';
import { AuthProvider } from './contexts/AuthContext';
import analytics from './services/analytics';

// Initialize TokenService with embedded JWT
tokenService.initializeWithEmbeddedJWT();

// Initialize analytics (GA4 + Source Digital pixel). No-op unless the
// production env vars are set, so dev/staging never sends data.
analytics.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
